// src/services/firebase-config.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA4xyFluQhoFhRl04u_PvBgFjWuv3-DemU",
  authDomain: "imazen-cd926.firebaseapp.com",
  projectId: "imazen-cd926",
  storageBucket: "imazen-cd926.firebasestorage.app",
  messagingSenderId: "375797050645",
  appId: "1:375797050645:web:db7ffd3f08781420960d1c",
  measurementId: "G-JWRQT1QEJ8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
